import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"


import Tab from '@shell/components/Tabbed/Tab.vue';
import Basic, { Props as BasicProps } from '@shell/components/Resource/Detail/ResourceTabs/SecretDataTab/Basic.vue';
import Ssh, { Props as SshProps } from '@shell/components/Resource/Detail/ResourceTabs/SecretDataTab/Ssh.vue';
import ServiceAccountToken, { Props as ServiceAccountTokenProps } from '@shell/components/Resource/Detail/ResourceTabs/SecretDataTab/ServiceAccountToken.vue';
import Certificate, { Props as CertificateProps } from '@shell/components/Resource/Detail/ResourceTabs/SecretDataTab/Certificate.vue';
import BasicAuth, { Props as BasicAuthProps } from '@shell/components/Resource/Detail/ResourceTabs/SecretDataTab/BasicAuth.vue';
import Registry, { Props as RegistryProps } from '@shell/components/Resource/Detail/ResourceTabs/SecretDataTab/Registry.vue';

export interface SecretData {
  basic?: BasicProps;
  basicAuth?: BasicAuthProps;
  ssh?: SshProps;
  serviceAccount?: ServiceAccountTokenProps;
  certificate?: CertificateProps;
  registry?: RegistryProps;
}

export interface Props {
  tabLabel: string;
  secretData: SecretData;

  weight?: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    tabLabel: {},
    secretData: {},
    weight: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tab, {
    class: "secret-data-tab",
    name: "data",
    label: props.tabLabel,
    weight: props.weight
  }, {
    default: _withCtx(() => [
      (props.secretData.registry)
        ? (_openBlock(), _createBlock(Registry, _normalizeProps(_mergeProps({ key: 0 }, props.secretData.registry)), null, 16))
        : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createTextVNode()),
      (props.secretData.basicAuth)
        ? (_openBlock(), _createBlock(BasicAuth, _normalizeProps(_mergeProps({ key: 1 }, props.secretData.basicAuth)), null, 16))
        : (props.secretData.certificate)
          ? (_openBlock(), _createBlock(Certificate, _normalizeProps(_mergeProps({ key: 2 }, props.secretData.certificate)), null, 16))
          : _createCommentVNode("", true),
      _cache[1] || (_cache[1] = _createTextVNode()),
      (props.secretData.serviceAccount)
        ? (_openBlock(), _createBlock(ServiceAccountToken, _normalizeProps(_mergeProps({ key: 3 }, props.secretData.serviceAccount)), null, 16))
        : _createCommentVNode("", true),
      _cache[2] || (_cache[2] = _createTextVNode()),
      (props.secretData.ssh)
        ? (_openBlock(), _createBlock(Ssh, _normalizeProps(_mergeProps({ key: 4 }, props.secretData.ssh)), null, 16))
        : _createCommentVNode("", true),
      _cache[3] || (_cache[3] = _createTextVNode()),
      (props.secretData.basic)
        ? (_openBlock(), _createBlock(Basic, _normalizeProps(_mergeProps({ key: 5 }, props.secretData.basic)), null, 16))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["label", "weight"]))
}
}

})